export enum DashboardMonthlyCostTypeEnum {
	FIXED_COST = 'FIXED_COST',
	VARIABLE_COST = 'VARIABLE_COST',
}
